<template>
  <label class="form-input-text">
    <slot />

    <input type="text"
      v-bind="$attrs"
      @input="$emit('input', $event.target.value)"
    />
  </label>
</template>

<script>
export default {
  name: 'VFormInputText',
  inheritAttrs: false,
};
</script>

<style lang="scss" scoped>
.form-input-text {
  display: block;

  input[type="text"] {
    display: block;
    width: 100%;
    padding: calc($gridGutter / 2);

    font-family: $fontFamily;
    font-size: $formInputFontSize;
    line-height: 1.25em;

    border: none;
    outline: none;

    &::-webkit-input-placeholder {
      color: inherit;
    }

    &::-moz-placeholder {
      color: inherit;
    }

    &:-ms-input-placeholder {
      color: inherit;
    }

    &:-moz-placeholder {
      color: inherit;
    }
  }

}
</style>
